export const tomQueryKeys = {
	all: ['tom-ai'] as const,
	conversations: () => [...tomQueryKeys.all, 'conversations'] as const,
	messages: (conversationId: number) =>
		[...tomQueryKeys.all, 'messages', conversationId] as const,
};
